import styled, { css, keyframes } from 'styled-components';
import { fadeIn, pulse } from '~styles/animations';
import { COLORS } from '~styles/tokens';


const shake = keyframes`
  0%, 100% {
    transform: rotate(0deg);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: rotate(-8deg);
  }
  20%, 40%, 60%, 80% {
    transform: rotate(8deg);
  }
`;


export const BadgeContainer = styled.button<{ hasNotifications?: boolean }>`
  position: relative;
  margin: 0 1.5rem;
  width: 2.5rem;
  height: 2.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 0.625rem;
  transition: all 0.2s ease;

  &:hover {
    background: ${COLORS.primary10};

    svg {
      color: ${COLORS.primary};
      transform: scale(1.05);
    }
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
    color: ${COLORS.textTertiary};
    transition: all 0.2s ease;
  }

  ${props => props.hasNotifications && css`
    &:hover svg {
      animation: ${shake} 0.5s ease-in-out;
    }
  `}
`;

export const BadgeCount = styled.span<{ animate?: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, ${COLORS.danger} 0%, ${COLORS.dangerHover} 100%);
  color: white;
  border-radius: 0.625rem;
  min-width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.625rem;
  font-weight: 700;
  padding: 0 0.25rem;
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
  animation: ${fadeIn} 0.3s ease;
  border: 2px solid white;

  ${props => props.animate && css`
    animation: ${pulse} 2s infinite;
  `}
`;

export const BellIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
